import { render, staticRenderFns } from "./MultiChoiceCard.vue?vue&type=template&id=7cf6ce27&"
import script from "./MultiChoiceCard.vue?vue&type=script&lang=ts&"
export * from "./MultiChoiceCard.vue?vue&type=script&lang=ts&"
import style0 from "./MultiChoiceCard.vue?vue&type=style&index=0&id=7cf6ce27&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports